module.exports = __webpack_public_path__ + "static/media/IND.b5128d71.png";